import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Alert, AlertDescription } from "@/components/ui/v2/alert";

const ClientAtsStep = () => {
  const { t } = useTranslation();

  return (
    <Alert variant="default" className="mt-2">
      <Info className="size-4" />
      <AlertDescription>
        {t(
          "admin.client.addClient.clientType.ATS.configureViaIntegrations",
          "Configure ATS on the Integrations page to sync jobs."
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ClientAtsStep;
